import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../components/usuarios_tienda/Sidebar";
import { useEffect, useState } from "react";
import { meUsuarioTienda } from "../services/LoginUserTienda";

const FULL_BLEED_PATH_SUFFIXES = [
  "/orders",
  "/products",
  "/nuevo",
  "/editar",
  "/categories",
  "/brands",
  "/customers",
  "/payment-methods",
  "/shipping-methods",
  "/zona-envios",
  "/tienda",
  "/config/users",
  "/config/roles",
];

function isFullBleedPath(pathname) {
  return FULL_BLEED_PATH_SUFFIXES.some((suffix) => pathname.endsWith(suffix));
}

function TiendaLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const fullBleed = isFullBleedPath(location.pathname);

  const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("tienda_token");

    if (!token) {
      navigate("/administracion/tienda/login", { replace: true });
      return;
    }

    let mounted = true;

    (async () => {
      try {
        const me = await meUsuarioTienda();

        if (!mounted) return;

        const usuario = me?.usuario || null;
        const permisos = me?.permisos || [];

        if (!usuario?.id) {
          throw new Error("Sesión inválida");
        }

        localStorage.setItem("tienda_data", JSON.stringify(usuario));
        localStorage.setItem("tienda_permisos", JSON.stringify(permisos));
        localStorage.setItem("tienda_usuario_id", String(usuario.id));
        localStorage.setItem("tienda_id", String(usuario.tienda_id || ""));
      } catch (e) {
        localStorage.removeItem("tienda_token");
        localStorage.removeItem("tienda_data");
        localStorage.removeItem("tienda_permisos");
        localStorage.removeItem("tienda_usuario_id");
        localStorage.removeItem("tienda_id");

        navigate("/administracion/tienda/login", { replace: true });
        return;
      } finally {
        if (mounted) setBooting(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  if (booting) return null;

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        background: "linear-gradient(135deg, #F4F7FB 0%, #EAF0F8 100%)",
      }}
    >
      <div
        style={{
          width: open ? (collapsed ? "70px" : "260px") : "0px",
          height: "100vh",
          position: screenWidth < 768 ? "fixed" : "relative",
          overflow: "hidden",
          zIndex: 3001,
          transition: "width 0.25s ease",
        }}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      <div
        style={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          height: "100vh",
          overflowY: fullBleed ? "hidden" : "auto",
          overflowX: "hidden",
          padding: fullBleed ? 0 : "20px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: fullBleed ? "stretch" : "center",
          scrollbarGutter: fullBleed ? undefined : "stable",
        }}
      >
        {fullBleed ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </div>
        ) : (
          <div
            style={{
              width: "min(100%, 1550px)",
              flexShrink: 0,
              minHeight: "calc(100vh - 80px)",
              background: "rgba(255,255,255,0.75)",
              backdropFilter: "blur(16px)",
              borderRadius: "16px",
              padding: "20px",
              marginBottom: "20px",
              border: "1px solid rgba(180,190,210,0.35)",
              boxShadow: "0px 8px 30px rgba(0,0,0,0.06)",
              overflow: "hidden",
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </div>
        )}
      </div>
    </div>
  );
}

export default TiendaLayout;